var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from "react";
import { ApplicationContext } from "../../../../ApplicationContext";
import Color from 'color';
import AssetIcon from "../../../pages/Assets/AssetIcon";
/**
 *
 */
var IconSelector = /** @class */ (function (_super) {
    __extends(IconSelector, _super);
    function IconSelector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSelector.prototype.render = function () {
        var _this = this;
        var _a;
        var assetIconNameToIconUrlDictionary = this.context.assetIconNameToIconUrlDictionary;
        var selectedIconName = this.props.selectedIconName;
        return (Array.from((_a = this.props.iconSelection) !== null && _a !== void 0 ? _a : assetIconNameToIconUrlDictionary.entries()).map(function (_a) {
            var _b;
            var iconName = _a[0], iconSource = _a[1];
            var style = { cursor: "pointer", display: "inline-block" };
            if (iconName == selectedIconName) {
                style["outline"] = '1px solid black';
            }
            return React.createElement("div", { style: style },
                React.createElement(AssetIcon, { onClick: function (e) {
                        _this.props.onSelect(iconName);
                    }, width: 60, src: iconSource, color: (_b = _this.props.color) !== null && _b !== void 0 ? _b : new Color([0, 0, 0, 255]) }));
        }));
    };
    return IconSelector;
}(React.Component));
IconSelector.contextType = ApplicationContext;
export default IconSelector;
